var _path, _path2, _path3, _path4, _rect, _rect2, _ellipse, _ellipse2, _ellipse3, _ellipse4, _circle, _circle2, _path5, _path6, _path7, _path8, _path9, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgDeleteAccount = function SvgDeleteAccount(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.1122 25.0424C46.5104 26.8586 49.2927 31.0616 47.911 36.4581",
    stroke: "#C4C4C4",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.21 38.7938C48.2929 38.4479 48.4089 37.5484 48.21 36.7182",
    stroke: "#C4C4C4",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8871 36.7154C46.2262 36.7132 47.0834 36.6068 47.7991 36.1993",
    stroke: "#C4C4C4",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6521 38.4529C46.9014 38.2111 47.4669 37.5256 47.735 36.7176",
    stroke: "#C4C4C4",
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 0.987495,
    height: 15.349,
    rx: 0.493747,
    transform: "matrix(0.994528 0.104475 -0.0945894 0.995516 25.4946 39.5135)",
    fill: "#C4C4C4"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 0.987607,
    height: 15.3475,
    rx: 0.493803,
    transform: "matrix(0.993335 -0.115259 0.104375 0.994538 33.6519 39.6296)",
    fill: "#C4C4C4"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 29.0814,
    cy: 22.965,
    rx: 16.7787,
    ry: 17.6424,
    fill: "url(#paint0_linear_180_23088)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 32.0423,
    cy: 22.965,
    rx: 16.7787,
    ry: 17.6424,
    fill: "url(#paint1_linear_180_23088)"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 32.0422,
    cy: 22.9653,
    rx: 12.8307,
    ry: 13.4913,
    fill: "white"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 32.0422,
    cy: 22.9653,
    rx: 12.8307,
    ry: 13.4913,
    fill: "url(#paint2_linear_180_23088)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27.7969,
    cy: 20.2354,
    r: 1.94533,
    fill: "#1C1C1C"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 36.875,
    cy: 20.2354,
    r: 1.94533,
    fill: "#1C1C1C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5879 29.1908C29.7394 27.6245 32.7332 25.4317 35.4967 29.1908",
    stroke: "#1C1C1C",
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3366 28.1561C12.9383 29.9722 10.156 34.1753 11.5378 39.5718",
    stroke: "#C4C4C4",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2388 41.9074C11.1559 41.5615 11.0398 40.6621 11.2388 39.8318",
    stroke: "#C4C4C4",
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5611 39.8289C13.222 39.8267 12.3649 39.7203 11.6492 39.3127",
    stroke: "#C4C4C4",
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7961 41.565C12.5469 41.3233 11.9813 40.6377 11.7132 39.8297",
    stroke: "#C4C4C4",
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_180_23088",
    x1: 29.0814,
    y1: 5.32259,
    x2: 29.0814,
    y2: 40.6074,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#868686"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_180_23088",
    x1: 45.4561,
    y1: 23.0867,
    x2: 19.6276,
    y2: 23.0867,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E2E2E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_180_23088",
    x1: 32.0422,
    y1: 9.47408,
    x2: 31.9453,
    y2: 52.4054,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ADADAD"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDeleteAccount, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/delete-account.931b3297.svg";
export { ForwardRef as ReactComponent };